import { TitleCasePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { OptionDropdown, SelectControl } from '../../../models/OptionDropdownSelect';
import { CodeAndDescription } from '../../../models/shared/CodeAndDescription';
import { createControl } from '../../../utilities/formUtilities';
import { CheckTransactionDetailsForm } from '../../../models/form/TransactionFormGroup';
import { SentenceCasePipe } from 'projects/money-movement-ui/src/app/shared/pipes/sentence-case.pipe';

@Component({
  standalone: false,
  selector: 'mm-check-reason',
  templateUrl: './check-reason.component.html',
  styleUrls: ['./check-reason.component.scss']  
})
export class CheckReasonComponent implements OnInit {
  @Input() parentForm!: FormGroup<CheckTransactionDetailsForm>;
  @Input() checkReasonMap: CodeAndDescription[];
  @Input() useStandingAuth: boolean;
  @Input() shouldDisableFieldForEditQcd: boolean = false;
  sentenceCasePipe = new SentenceCasePipe;
  controlName: string = 'checkReason';
  checkReasonModel: SelectControl = {
    title: 'Check reason',
    controlName: this.controlName,
    options: [],
    validationMessage: '',
    showOptionalLabel: true
  };

  constructor(private titleCasePipe: TitleCasePipe) { }

  ngOnInit(): void {
    createControl(this.parentForm, this.controlName, '');

    this.setDropDownOptions();
    if (this.useStandingAuth || this.shouldDisableFieldForEditQcd) {
      this.checkReason?.disable();
    }

  }

  setDropDownOptions(): void {
    this.checkReasonModel.options = this.checkReasonMap.map(element => new OptionDropdown(element.code, this.sentenceCasePipe.transform(element.description)));
  }

  get checkReason() {
    return this.parentForm.controls.checkReason;
  }
}
